import { HTTP } from './helpers/http.js'
import qs from 'qs'

const site = {
  getById(organizationId, siteId) {
    const url = `/api/v1/organizations/${organizationId}/sites/${siteId}`
    return HTTP.get(url)
  },

  getOrganizationSites(organizationId, options = {}) {
    const params = {
      params: options || {},
      paramsSerializer: function(params) {
        return qs.stringify(params, { arrayFormat: 'brackets' })
      },
    }

    const url = `/api/v1/organizations/${organizationId}/sites`
    return HTTP.get(url, params)
  },

  createOrganizationSite(organizationId, data) {
    const url = `/api/v1/organizations/${organizationId}/sites`
    return HTTP.post(url, data)
  },

  updateOrganizationSite(organizationId, siteId, data) {
    const url = `/api/v1/organizations/${organizationId}/sites/${siteId}`
    return HTTP.patch(url, data)
  },

  getStreamSites(organizationId, options) {
    const params = {
      params: options || {},
      paramsSerializer: function(params) {
        return qs.stringify(params, { arrayFormat: 'brackets' })
      },
    }

    const url = `/api/v1/stream/${organizationId}/sites/`
    return HTTP.get(url, params)
  },
}
export default site
